import React, { useState, useEffect} from "react";
import {getContent} from '../react-hooks/useContentCompiler'
import {useApplicationContext} from '../provider'
import '../product-css/compiled/app.css'
import SEO from "../components/SEO";
import queryString from 'query-string'
import { loadScript } from '../utils/scriptLoader'

const Producthelp = ({location}) => {    
    // const {config}  = pathContext    
    const { handleBarCompiler } = useApplicationContext()    
        // eslint-disable-next-line react-hooks/rules-of-hooks
    // const helpContent = getContent(config.template_file, handleBarCompiler, context)
    const [loaded, setLoaded] = useState(false);
    const [content, setContent] = useState('')
    const [helpContext, setHelpContext] = useState({})
    let rawContactTemplate
    if(location.pathname.includes("emergency")){
    rawContactTemplate = require(`raw-loader!../compiled/braintree/templates/forms/emergency.hbs`)
    }
    else{
        rawContactTemplate = require(`raw-loader!../compiled/braintree/templates/forms/contact.hbs`)
    }
    const rawAttachmentFailTemplate = require(`raw-loader!../compiled/braintree/templates/forms/attachment-upload-fail.hbs`)
    const successTemplate = require(`raw-loader!../compiled/braintree/templates/forms/success.hbs`)
    const templates = {
        'contact': rawContactTemplate,
        'attachment-upload-fail': rawAttachmentFailTemplate,
        'success': successTemplate
    }
    
    const loadScripts = async () => {
        try {
            await loadScript({ src: 'https://www.google.com/recaptcha/api.js', async:true, defer:true })
        } catch (err) {
          console.log('recaptcha script loading error')
        }
      }
    useEffect(() => {
        if(typeof window !== `undefined` && loaded){
            // const ContactForm = require('../handlebars/braintree/lib/contact')
            if(location.pathname.includes("emergency")){
                let emergencyForm = new window.BTBaseLib.EmergencyForm();
                emergencyForm.init();
            }
            else{
                let contactForm = new window.BTBaseLib.ContactForm();
                contactForm.init();
            }
            (async function() {
                await loadScripts();
            })();
        }  
    }, [loaded])

    useEffect(() => {
        let context = window.BTHandlebarLib.initialize({location})
        const queryParams =  queryString.parse(location.search)
        window.BTHandlebarLib.setHelpPageContext({context, queryParams})    
        setContent(getContent(rawContactTemplate, handleBarCompiler, context))
        setLoaded(true)
        setHelpContext(context)
        if(typeof window !== 'undefined'){
            window.addEventListener('contextChange', (data)=>{
                setLoaded(false)
                let newContext = {
                    ...context,
                    ...data.detail.context
                }
                const newContent = getContent(templates[data.detail.form], handleBarCompiler, newContext)
                setContent(newContent)
                setHelpContext(newContext)
                if(data.detail.form === 'contact'|| data.detail.form === 'emergency') setLoaded(true) // this will trigger initializing contact form events
            })
        }
        
    }, [])

    useEffect(() => {
        window.BTHandlebarLib.templateManager.registerHelpers()
    })
    
    return(
        <>  
         <SEO context={helpContext} />  
            
            <div dangerouslySetInnerHTML={{__html: content}} /> 
        </>
    )

}

export default Producthelp